var spaces = [
	{
		name: "Technical Space: Tank Room CWS Size A",
		label: "Tank Room CWS",
		source: "UK",
		spaceType: "Tank Room CWS Sprinkler",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Single",
			area: [
				16,
				999999
			],
			levelLocation: [
				"Lowest"
			],
			sizeX: [
				3.3,
				999999
			],
			sizeZ: [
				3.3,
				999999
			],
			sizeY: [
				3.5,
				999999
			],
			tryAdjacent: [
				"Tank Room CWS Sprinkler",
				"Tank Room RWH",
				"Tank Room Grey Water",
				"Building Thermal Energy",
				"Central Thermal Energy"
			],
			tryAvoid: [
				"Electrical Intake",
				"Electrical Backup Power"
			]
		},
		conditions: {
			Sprinklered: false,
			Ffl: [
				0,
				11
			],
			Units: [
				10,
				30
			]
		}
	},
	{
		name: "Technical Space: Tank Room CWS Size B",
		label: "Tank Room CWS",
		source: "UK",
		spaceType: "Tank Room CWS Sprinkler",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				16,
				999999
			],
			levelLocation: [
				"Lowest"
			],
			sizeX: [
				3.3,
				999999
			],
			sizeZ: [
				3.3,
				999999
			],
			sizeY: [
				3.5,
				999999
			],
			tryAdjacent: [
				"Tank Room CWS Sprinkler",
				"Tank Room RWH",
				"Tank Room Grey Water",
				"Building Thermal Energy",
				"Central Thermal Energy"
			],
			tryAvoid: [
				"Electrical Intake",
				"Electrical Backup Power"
			]
		},
		conditions: {
			Sprinklered: true,
			Ffl: [
				0,
				30
			],
			Units: [
				10,
				30
			]
		}
	},
	{
		name: "Technical Space: Tank Room CWS Size C",
		label: "Tank Room CWS",
		source: "UK",
		spaceType: "Tank Room CWS Sprinkler",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Single",
			area: [
				24,
				999999
			],
			levelLocation: [
				"Lowest"
			],
			sizeX: [
				3.3,
				999999
			],
			sizeZ: [
				5,
				999999
			],
			sizeY: [
				3.5,
				999999
			],
			tryAdjacent: [
				"Tank Room CWS Sprinkler",
				"Tank Room RWH",
				"Tank Room Grey Water",
				"Building Thermal Energy",
				"Central Thermal Energy"
			],
			tryAvoid: [
				"Electrical Intake",
				"Electrical Backup Power"
			]
		},
		conditions: {
			Sprinklered: false,
			Ffl: [
				0,
				11
			],
			Units: [
				30,
				100
			]
		}
	},
	{
		name: "Technical Space: Tank Room CWS Size D",
		label: "Tank Room CWS",
		source: "UK",
		spaceType: "Tank Room CWS Sprinkler",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				42,
				999999
			],
			levelLocation: [
				"Lowest"
			],
			sizeX: [
				5,
				999999
			],
			sizeZ: [
				5.8,
				999999
			],
			sizeY: [
				3.5,
				999999
			],
			tryAdjacent: [
				"Tank Room CWS Sprinkler",
				"Tank Room RWH",
				"Tank Room Grey Water",
				"Building Thermal Energy",
				"Central Thermal Energy"
			],
			tryAvoid: [
				"Electrical Intake",
				"Electrical Backup Power"
			]
		},
		conditions: {
			Sprinklered: true,
			Ffl: [
				11,
				50
			],
			Units: [
				30,
				100
			]
		}
	},
	{
		name: "Technical Space: Tank Room CWS Size E",
		label: "Tank Room CWS",
		source: "UK",
		spaceType: "Tank Room CWS Sprinkler",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				42,
				999999
			],
			levelLocation: [
				"Lowest"
			],
			sizeX: [
				5,
				999999
			],
			sizeZ: [
				5.8,
				999999
			],
			sizeY: [
				3.5,
				999999
			],
			tryAdjacent: [
				"Tank Room CWS Sprinkler",
				"Tank Room RWH",
				"Tank Room Grey Water",
				"Building Thermal Energy",
				"Central Thermal Energy"
			],
			tryAvoid: [
				"Electrical Intake",
				"Electrical Backup Power"
			]
		},
		conditions: {
			Sprinklered: true,
			Ffl: [
				50,
				1000
			],
			Units: [
				30,
				100
			]
		}
	},
	{
		name: "Technical Space: Tank Room CWS Size F",
		label: "Tank Room CWS",
		source: "UK",
		spaceType: "Tank Room CWS Sprinkler",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Single",
			area: [
				72,
				999999
			],
			levelLocation: [
				"Lowest"
			],
			sizeX: [
				7.5,
				999999
			],
			sizeZ: [
				6.7,
				999999
			],
			sizeY: [
				3.5,
				999999
			],
			tryAdjacent: [
				"Tank Room CWS Sprinkler",
				"Tank Room RWH",
				"Tank Room Grey Water",
				"Building Thermal Energy",
				"Central Thermal Energy"
			],
			tryAvoid: [
				"Electrical Intake",
				"Electrical Backup Power"
			]
		},
		conditions: {
			Sprinklered: false,
			Ffl: [
				0,
				11
			],
			Units: [
				100,
				1000
			]
		}
	},
	{
		name: "Technical Space: Tank Room CWS Size G",
		label: "Tank Room CWS",
		source: "UK",
		spaceType: "Tank Room CWS Sprinkler",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				72,
				999999
			],
			levelLocation: [
				"Lowest"
			],
			sizeX: [
				7.5,
				999999
			],
			sizeZ: [
				6.7,
				999999
			],
			sizeY: [
				3.5,
				999999
			],
			tryAdjacent: [
				"Tank Room CWS Sprinkler",
				"Tank Room RWH",
				"Tank Room Grey Water",
				"Building Thermal Energy",
				"Central Thermal Energy"
			],
			tryAvoid: [
				"Electrical Intake",
				"Electrical Backup Power"
			]
		},
		conditions: {
			Sprinklered: true,
			Ffl: [
				11,
				50
			],
			Units: [
				100,
				1000
			]
		}
	},
	{
		name: "Technical Space: Tank Room CWS Size H",
		label: "Tank Room CWS",
		source: "UK",
		spaceType: "Tank Room CWS Sprinkler",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				80,
				999999
			],
			levelLocation: [
				"Lowest"
			],
			sizeX: [
				8.3,
				999999
			],
			sizeZ: [
				6.7,
				999999
			],
			sizeY: [
				3.5,
				999999
			],
			tryAdjacent: [
				"Tank Room CWS Sprinkler",
				"Tank Room RWH",
				"Tank Room Grey Water",
				"Building Thermal Energy",
				"Central Thermal Energy"
			],
			tryAvoid: [
				"Electrical Intake",
				"Electrical Backup Power"
			]
		},
		conditions: {
			Sprinklered: true,
			Ffl: [
				50,
				1000
			],
			Units: [
				100,
				1000
			]
		}
	},
	{
		name: "Technical Space: Tank Room Rainwater Harvesting A",
		label: "Tank Room Rainwater Harvesting",
		source: "UK",
		spaceType: "Tank Room RWH",
		spaceClass: "Service",
		userSelectable: true,
		consolidationType: false,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				16,
				999999
			],
			levelLocation: [
				"Lowest"
			],
			sizeX: [
				3.3,
				999999
			],
			sizeZ: [
				3.3,
				999999
			],
			sizeY: [
				3.5,
				999999
			],
			tryAdjacent: [
				"Tank Room CWS Sprinkler",
				"Tank Room RWH",
				"Tank Room Grey Water",
				"Building Thermal Energy",
				"Central Thermal Energy"
			],
			tryAvoid: [
				"Electrical Intake",
				"Electrical Backup Power"
			]
		},
		conditions: {
			Ffl: [
				0,
				1000
			],
			Units: [
				0,
				1000
			]
		}
	},
	{
		name: "Technical Space: Tank Room Black_Grey Water Harvesting A",
		label: "Tank Room Grey Water Harvesting",
		source: "UK",
		spaceType: "Tank Room Grey Water",
		spaceClass: "Service",
		userSelectable: true,
		consolidationType: false,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				32,
				999999
			],
			levelLocation: [
				"Lowest"
			],
			sizeX: [
				6.7,
				999999
			],
			sizeZ: [
				3.3,
				999999
			],
			sizeY: [
				3.5,
				999999
			],
			tryAdjacent: [
				"Tank Room CWS Sprinkler",
				"Tank Room RWH",
				"Tank Room Grey Water",
				"Building Thermal Energy",
				"Central Thermal Energy"
			],
			tryAvoid: [
				"Electrical Intake",
				"Electrical Backup Power"
			]
		},
		conditions: {
			Ffl: [
				0,
				1000
			],
			Units: [
				0,
				1000
			]
		}
	},
	{
		name: "Technical Space: Electrical Primary LV Room Size A",
		label: "Electrical Primary LV Room",
		source: "UK",
		spaceType: "Electrical Intake",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				12,
				999999
			],
			levelLocation: [
				"Ground",
				"Lowest"
			],
			preferFacadeLocation: [
				"Secondary",
				"Tertiary"
			],
			requiredAvoid: [
				"Electrical Backup Power"
			],
			sizeX: [
				3,
				999999
			],
			sizeZ: [
				4,
				999999
			],
			sizeY: [
				3,
				999999
			],
			tryAdjacent: [
				"Electrical Intake"
			],
			tryAvoid: [
				"Electrical Backup Power"
			]
		},
		conditions: {
			Ffl: [
				0,
				1000
			],
			Units: [
				10,
				100
			]
		}
	},
	{
		name: "Technical Space: Electrical Primary LV Room Size B",
		label: "Electrical Primary LV Room",
		source: "UK",
		spaceType: "Electrical Intake",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				32,
				999999
			],
			levelLocation: [
				"Ground",
				"Lowest"
			],
			preferFacadeLocation: [
				"Secondary",
				"Tertiary"
			],
			requiredAvoid: [
				"Electrical Backup Power"
			],
			sizeX: [
				8,
				999999
			],
			sizeZ: [
				4,
				999999
			],
			sizeY: [
				3,
				999999
			],
			tryAdjacent: [
				"Electrical Intake"
			],
			tryAvoid: [
				"Electrical Backup Power"
			]
		},
		conditions: {
			Ffl: [
				0,
				1000
			],
			Units: [
				100,
				1000
			]
		}
	},
	{
		name: "Technical Space: Electrical Substation  A",
		label: "Electrical Substation",
		source: "UK",
		spaceType: "Electrical Mains Intake",
		spaceClass: "Service",
		userSelectable: true,
		consolidationType: false,
		attributes: {
			access: "Street",
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				16,
				999999
			],
			levelLocation: [
				"Ground",
				"Lowest"
			],
			preferFacadeLocation: [
				"Primary"
			],
			requiredAvoid: [
				"Apartment",
				"Electrical Backup Power"
			],
			sizeX: [
				4,
				999999
			],
			sizeZ: [
				4,
				999999
			],
			sizeY: [
				3,
				999999
			],
			tryAvoid: [
				"Electrical Backup Power"
			]
		},
		conditions: {
			Ffl: [
				0,
				1000
			],
			Units: [
				0,
				1000
			]
		}
	},
	{
		name: "Technical Space: Primary Comms Room A",
		label: "Primary Comms Room",
		source: "UK",
		spaceType: "Electrical BMS / Comms",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Single",
			area: [
				9,
				999999
			],
			levelLocation: [
				"Ground",
				"Lowest"
			],
			sizeX: [
				3,
				999999
			],
			sizeZ: [
				3,
				999999
			],
			sizeY: [
				2.4,
				999999
			]
		},
		conditions: {
			Ffl: [
				0,
				1000
			],
			Units: [
				30,
				1000
			]
		}
	},
	{
		name: "Technical Space: Generator Room Roof A",
		label: "Generator Room",
		source: "UK",
		spaceType: "Electrical Backup Power",
		spaceClass: "Service",
		userSelectable: true,
		consolidationType: false,
		attributes: {
			access: "Street",
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: false,
			requiredOutside: true,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				65,
				999999
			],
			levelLocation: [
				"Roof"
			],
			preferFacadeLocation: [
				"Primary"
			],
			requiredAvoid: [
				"Apartment",
				"Electrical Intake"
			],
			sizeX: [
				13,
				999999
			],
			sizeZ: [
				5,
				999999
			],
			sizeY: [
				4,
				999999
			],
			tryAvoid: [
				"Electrical Intake"
			]
		},
		conditions: {
			"Generator": true,
			Ffl: [
				0,
				1000
			],
			Units: [
				30,
				1000
			]
		}
	},
	{
		name: "Technical Space: Generator Room Lowest Level A",
		label: "Generator Room",
		source: "UK",
		spaceType: "Electrical Backup Power",
		spaceClass: "Service",
		userSelectable: true,
		consolidationType: false,
		attributes: {
			access: "Street",
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				91,
				999999
			],
			levelLocation: [
				"Ground",
				"Lowest"
			],
			requiredAvoid: [
				"Apartment",
				"Electrical Intake"
			],
			sizeX: [
				13,
				999999
			],
			sizeZ: [
				7,
				999999
			],
			sizeY: [
				4,
				999999
			],
			tryAvoid: [
				"Electrical Intake"
			]
		},
		conditions: {
			"Generator": true,
			Ffl: [
				0,
				1000
			],
			Units: [
				30,
				1000
			]
		}
	},
	{
		name: "Technical Space: Electrical Secondary LV Room A",
		label: "Electrical Secondary LV Room",
		source: "UK",
		spaceType: "Electrical Backup Power",
		spaceClass: "Service",
		userSelectable: true,
		consolidationType: false,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				12,
				999999
			],
			levelLocation: [
				"Ground",
				"Lowest"
			],
			requiredAvoid: [
				"Electrical Intake"
			],
			sizeX: [
				3,
				999999
			],
			sizeZ: [
				4,
				999999
			],
			sizeY: [
				3,
				999999
			],
			tryAvoid: [
				"Electrical Intake"
			]
		},
		conditions: {
			"Generator": false,
			Ffl: [
				0,
				1000
			],
			Units: [
				30,
				1000
			]
		}
	},
	{
		name: "Technical Space: Building Heat Pump Small A",
		label: "Building Heat Pump",
		source: "UK",
		spaceType: "Building Thermal Energy",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: false,
			requiredOutside: true,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Single",
			area: [
				48,
				999999
			],
			levelLocation: [
				"Roof"
			],
			sizeX: [
				6.7,
				999999
			],
			sizeZ: [
				5,
				999999
			],
			sizeY: [
				2.4,
				999999
			],
			tryAdjacent: [
				"Tank Room CWS Sprinkler",
				"Tank Room RWH",
				"Tank Room Grey Water",
				"Building Thermal Energy",
				"Central Thermal Energy"
			],
			tryAvoid: [
				"Electrical Intake",
				"Electrical Backup Power"
			]
		},
		conditions: {
			CentralASHP: true,
			Ffl: [
				0,
				18
			],
			Units: [
				10,
				30
			]
		}
	},
	{
		name: "Technical Space: Building Heat Pump Small B",
		label: "Building Heat Pump",
		source: "UK",
		spaceType: "Building Thermal Energy",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: false,
			requiredOutside: true,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Single",
			area: [
				60,
				999999
			],
			levelLocation: [
				"Roof"
			],
			sizeX: [
				8.3,
				999999
			],
			sizeZ: [
				5,
				999999
			],
			sizeY: [
				2.4,
				999999
			],
			tryAdjacent: [
				"Tank Room CWS Sprinkler",
				"Tank Room RWH",
				"Tank Room Grey Water",
				"Building Thermal Energy",
				"Central Thermal Energy"
			],
			tryAvoid: [
				"Electrical Intake",
				"Electrical Backup Power"
			]
		},
		conditions: {
			CentralASHP: true,
			Ffl: [
				18,
				50
			],
			Units: [
				10,
				30
			]
		}
	},
	{
		name: "Technical Space: Building Heat Pump Medium A",
		label: "Building Heat Pump",
		source: "UK",
		spaceType: "Building Thermal Energy",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: false,
			requiredOutside: true,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				54,
				999999
			],
			levelLocation: [
				"Roof"
			],
			sizeX: [
				7.5,
				999999
			],
			sizeZ: [
				5,
				999999
			],
			sizeY: [
				2.4,
				999999
			],
			tryAdjacent: [
				"Tank Room CWS Sprinkler",
				"Tank Room RWH",
				"Tank Room Grey Water",
				"Building Thermal Energy",
				"Central Thermal Energy"
			],
			tryAvoid: [
				"Electrical Intake",
				"Electrical Backup Power"
			]
		},
		conditions: {
			CentralASHP: true,
			Ffl: [
				0,
				50
			],
			Units: [
				30,
				100
			]
		}
	},
	{
		name: "Technical Space: Building Heat Pump Large A",
		label: "Building Heat Pump",
		source: "UK",
		spaceType: "Building Thermal Energy",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: false,
			requiredOutside: true,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				54,
				999999
			],
			levelLocation: [
				"Roof"
			],
			sizeX: [
				7.5,
				999999
			],
			sizeZ: [
				5,
				999999
			],
			sizeY: [
				2.4,
				999999
			],
			tryAdjacent: [
				"Tank Room CWS Sprinkler",
				"Tank Room RWH",
				"Tank Room Grey Water",
				"Building Thermal Energy",
				"Central Thermal Energy"
			],
			tryAvoid: [
				"Electrical Intake",
				"Electrical Backup Power"
			]
		},
		conditions: {
			CentralASHP: true,
			Ffl: [
				0,
				1000
			],
			Units: [
				100,
				1000
			]
		}
	},
	{
		name: "Technical Space: Building Heat Pump Ancillaries Space A",
		label: "Building Heat Pump",
		source: "UK",
		spaceType: "Building Thermal Energy",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: true,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				24,
				999999
			],
			levelLocation: [
				"Roof"
			],
			sizeX: [
				3.3,
				999999
			],
			sizeZ: [
				5,
				999999
			],
			sizeY: [
				2.4,
				999999
			],
			tryAdjacent: [
				"Tank Room CWS Sprinkler",
				"Tank Room RWH",
				"Tank Room Grey Water",
				"Building Thermal Energy",
				"Central Thermal Energy"
			],
			tryAvoid: [
				"Electrical Intake",
				"Electrical Backup Power"
			]
		},
		conditions: {
			CentralASHP: true,
			Ffl: [
				0,
				1000
			],
			Units: [
				30,
				1000
			]
		}
	},
	{
		name: "Technical Space: Ambient Loop Small A",
		label: "Ambient Loop",
		source: "UK",
		spaceType: "Building Thermal Energy",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Single",
			area: [
				12,
				999999
			],
			levelLocation: [
				"Lowest",
				"Ground"
			],
			sizeX: [
				2.5,
				999999
			],
			sizeZ: [
				3.3,
				999999
			],
			sizeY: [
				2.4,
				999999
			],
			tryAdjacent: [
				"Tank Room CWS Sprinkler",
				"Tank Room RWH",
				"Tank Room Grey Water",
				"Building Thermal Energy",
				"Central Thermal Energy"
			],
			tryAvoid: [
				"Electrical Intake",
				"Electrical Backup Power"
			]
		},
		conditions: {
			DistrictHeating: true,
			Ffl: [
				0,
				30
			],
			Units: [
				10,
				30
			]
		}
	},
	{
		name: "Technical Space: Ambient Loop Large A",
		label: "Ambient Loop",
		source: "UK",
		spaceType: "Building Thermal Energy",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				24,
				999999
			],
			levelLocation: [
				"Lowest",
				"Ground"
			],
			sizeX: [
				3.3,
				999999
			],
			sizeZ: [
				5,
				999999
			],
			sizeY: [
				2.4,
				999999
			],
			tryAdjacent: [
				"Tank Room CWS Sprinkler",
				"Tank Room RWH",
				"Tank Room Grey Water",
				"Building Thermal Energy",
				"Central Thermal Energy"
			],
			tryAvoid: [
				"Electrical Intake",
				"Electrical Backup Power"
			]
		},
		conditions: {
			DistrictHeating: true,
			Ffl: [
				30,
				1000
			],
			Units: [
				30,
				1000
			]
		}
	},
	{
		name: "Technical Space: District Heating Plant Room Small A",
		label: "District Heating Plant Room",
		source: "UK",
		spaceType: "Central Thermal Energy",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				18,
				999999
			],
			levelLocation: [
				"Lowest",
				"Ground"
			],
			sizeX: [
				3.3,
				999999
			],
			sizeZ: [
				3.8,
				999999
			],
			sizeY: [
				2.4,
				999999
			],
			tryAdjacent: [
				"Tank Room CWS Sprinkler",
				"Tank Room RWH",
				"Tank Room Grey Water",
				"Building Thermal Energy",
				"Central Thermal Energy"
			],
			tryAvoid: [
				"Electrical Intake",
				"Electrical Backup Power"
			]
		},
		conditions: {
			EnergyCentre: true,
			Ffl: [
				0,
				30
			],
			Units: [
				10,
				30
			]
		}
	},
	{
		name: "Technical Space: District Heating Plant Room Medium  A",
		label: "District Heating Plant Room",
		source: "UK",
		spaceType: "Central Thermal Energy",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				27,
				999999
			],
			levelLocation: [
				"Lowest",
				"Ground"
			],
			sizeX: [
				3.8,
				999999
			],
			sizeZ: [
				5,
				999999
			],
			sizeY: [
				2.4,
				999999
			],
			tryAdjacent: [
				"Tank Room CWS Sprinkler",
				"Tank Room RWH",
				"Tank Room Grey Water",
				"Building Thermal Energy",
				"Central Thermal Energy"
			],
			tryAvoid: [
				"Electrical Intake",
				"Electrical Backup Power"
			]
		},
		conditions: {
			EnergyCentre: true,
			Ffl: [
				0,
				50
			],
			Units: [
				30,
				100
			]
		}
	},
	{
		name: "Technical Space: District Heating Plant Room Medium B",
		label: "District Heating Plant Room",
		source: "UK",
		spaceType: "Central Thermal Energy",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				35,
				999999
			],
			levelLocation: [
				"Lowest",
				"Ground"
			],
			sizeX: [
				4.2,
				999999
			],
			sizeZ: [
				5.8,
				999999
			],
			sizeY: [
				2.4,
				999999
			],
			tryAdjacent: [
				"Tank Room CWS Sprinkler",
				"Tank Room RWH",
				"Tank Room Grey Water",
				"Building Thermal Energy",
				"Central Thermal Energy"
			],
			tryAvoid: [
				"Electrical Intake",
				"Electrical Backup Power"
			]
		},
		conditions: {
			EnergyCentre: true,
			Ffl: [
				50,
				1000
			],
			Units: [
				30,
				100
			]
		}
	},
	{
		name: "Technical Space: District Heating Plant Room Large  A",
		label: "District Heating Plant Room",
		source: "UK",
		spaceType: "Central Thermal Energy",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				35,
				999999
			],
			levelLocation: [
				"Lowest",
				"Ground"
			],
			sizeX: [
				4.2,
				999999
			],
			sizeZ: [
				5.8,
				999999
			],
			sizeY: [
				2.4,
				999999
			],
			tryAdjacent: [
				"Tank Room CWS Sprinkler",
				"Tank Room RWH",
				"Tank Room Grey Water",
				"Building Thermal Energy",
				"Central Thermal Energy"
			],
			tryAvoid: [
				"Electrical Intake",
				"Electrical Backup Power"
			]
		},
		conditions: {
			EnergyCentre: true,
			Ffl: [
				0,
				50
			],
			Units: [
				100,
				1000
			]
		}
	},
	{
		name: "Technical Space: District Heating Plant Room Large B",
		label: "District Heating Plant Room",
		source: "UK",
		spaceType: "Central Thermal Energy",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				40,
				999999
			],
			levelLocation: [
				"Lowest",
				"Ground"
			],
			sizeX: [
				6.7,
				999999
			],
			sizeZ: [
				4.2,
				999999
			],
			sizeY: [
				2.4,
				999999
			],
			tryAdjacent: [
				"Tank Room CWS Sprinkler",
				"Tank Room RWH",
				"Tank Room Grey Water",
				"Building Thermal Energy",
				"Central Thermal Energy"
			],
			tryAvoid: [
				"Electrical Intake",
				"Electrical Backup Power"
			]
		},
		conditions: {
			EnergyCentre: true,
			Ffl: [
				50,
				1000
			],
			Units: [
				100,
				1000
			]
		}
	},
	{
		name: "Utility Space: Cycle Store Size A",
		label: "Cycle Store",
		source: "UK",
		spaceType: "Cycle Store",
		spaceClass: "Amenity",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			canRotate: true,
			preferredInside: true,
			preferredOutside: false,
			quantity: 0.5,
			quantityUnit: "Units1B1P",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				1.6,
				999999
			],
			avoidFacadeLocation: [
				"Primary"
			],
			levelLocation: [
				"Ground"
			],
			preferFacadeLocation: [
				"Secondary",
				"Tertiary"
			],
			sizeZ: [
				4,
				999999
			],
			sizeY: [
				2.4,
				999999
			],
			tryAvoid: [
				"Entrance"
			]
		},
		conditions: {
			Ffl: [
				0,
				1000
			],
			Units1B1P: [
				1,
				1000
			]
		}
	},
	{
		name: "Utility Space: Cycle Store Size B",
		label: "Cycle Store",
		source: "UK",
		spaceType: "Cycle Store",
		spaceClass: "Amenity",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			canRotate: true,
			preferredInside: true,
			preferredOutside: false,
			quantity: 0.5,
			quantityUnit: "UnitsStudio",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				1.6,
				999999
			],
			avoidFacadeLocation: [
				"Primary"
			],
			levelLocation: [
				"Ground"
			],
			preferFacadeLocation: [
				"Secondary",
				"Tertiary"
			],
			sizeZ: [
				4,
				999999
			],
			sizeY: [
				2.4,
				999999
			],
			tryAvoid: [
				"Entrance"
			]
		},
		conditions: {
			Ffl: [
				0,
				1000
			],
			UnitsStudio: [
				1,
				1000
			]
		}
	},
	{
		name: "Utility Space: Cycle Store Size C",
		label: "Cycle Store",
		source: "UK",
		spaceType: "Cycle Store",
		spaceClass: "Amenity",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			canRotate: true,
			preferredInside: true,
			preferredOutside: false,
			quantity: 0.8,
			quantityUnit: "Units1B2P",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				1.6,
				999999
			],
			avoidFacadeLocation: [
				"Primary"
			],
			levelLocation: [
				"Ground"
			],
			preferFacadeLocation: [
				"Secondary",
				"Tertiary"
			],
			sizeZ: [
				4,
				999999
			],
			sizeY: [
				2.4,
				999999
			],
			tryAvoid: [
				"Entrance"
			]
		},
		conditions: {
			Ffl: [
				0,
				1000
			],
			Units1B2P: [
				1,
				1000
			]
		}
	},
	{
		name: "Utility Space: Cycle Store Size D",
		label: "Cycle Store",
		source: "UK",
		spaceType: "Cycle Store",
		spaceClass: "Amenity",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			canRotate: true,
			preferredInside: true,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Units2B",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				1.6,
				999999
			],
			avoidFacadeLocation: [
				"Primary"
			],
			levelLocation: [
				"Ground"
			],
			preferFacadeLocation: [
				"Secondary",
				"Tertiary"
			],
			sizeZ: [
				4,
				999999
			],
			sizeY: [
				2.4,
				999999
			],
			tryAvoid: [
				"Entrance"
			]
		},
		conditions: {
			Ffl: [
				0,
				1000
			],
			Units2B: [
				1,
				1000
			]
		}
	},
	{
		name: "Utility Space: Waste Store - Small",
		label: "Waste Store",
		source: "UK",
		spaceType: "Bin Store",
		spaceClass: "Amenity",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: false,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				15,
				999999
			],
			avoidFacadeLocation: [
				"Primary"
			],
			levelLocation: [
				"Ground"
			],
			preferFacadeLocation: [
				"Tertiary",
				"Secondary"
			],
			sizeX: [
				3,
				999999
			],
			sizeZ: [
				3,
				999999
			],
			sizeY: [
				2.4,
				999999
			],
			tryAdjacent: [
				"Core"
			],
			tryAvoid: [
				"Entrance"
			]
		},
		conditions: {
			Units: [
				10,
				30
			]
		}
	},
	{
		name: "Utility Space: Waste Store - Medium",
		label: "Waste Store",
		source: "UK",
		spaceType: "Bin Store",
		spaceClass: "Amenity",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: false,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				35,
				999999
			],
			avoidFacadeLocation: [
				"Primary"
			],
			levelLocation: [
				"Ground"
			],
			preferFacadeLocation: [
				"Tertiary",
				"Secondary"
			],
			sizeX: [
				6,
				999999
			],
			sizeZ: [
				5.9,
				999999
			],
			sizeY: [
				2.4,
				999999
			],
			tryAdjacent: [
				"Core"
			],
			tryAvoid: [
				"Entrance"
			]
		},
		conditions: {
			Units: [
				30,
				100
			]
		}
	},
	{
		name: "Utility Space: Waste Store - Large",
		label: "Waste Store",
		source: "UK",
		spaceType: "Bin Store",
		spaceClass: "Amenity",
		userSelectable: false,
		consolidationType: false,
		attributes: {
			canRotate: true,
			preferredInside: false,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: false,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				100,
				999999
			],
			avoidFacadeLocation: [
				"Primary"
			],
			levelLocation: [
				"Ground"
			],
			preferFacadeLocation: [
				"Tertiary",
				"Secondary"
			],
			sizeX: [
				8,
				999999
			],
			sizeZ: [
				5.9,
				999999
			],
			sizeY: [
				2.4,
				999999
			],
			tryAdjacent: [
				"Core"
			],
			tryAvoid: [
				"Entrance"
			]
		},
		conditions: {
			Units: [
				100,
				1000
			]
		}
	},
	{
		name: "Cycle Store Room",
		label: "Cycle Store",
		source: "UK",
		spaceType: "Cycle Store",
		spaceClass: "Amenity",
		userSelectable: false,
		consolidationType: true,
		attributes: {
			canRotate: false,
			preferredInside: true,
			preferredOutside: false,
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			avoidFacadeLocation: [
				"Primary"
			],
			consolidates: [
				"Cycle Store"
			],
			levelLocation: [
				"Ground"
			],
			preferFacadeLocation: [
				"Secondary",
				"Tertiary"
			],
			sizeX: [
				0.4,
				999999
			],
			sizeZ: [
				4,
				999999
			],
			sizeY: [
				2.4,
				999999
			],
			tryAvoid: [
				"Entrance"
			]
		},
		conditions: {
		}
	},
	{
		name: "Combined Plantroom Small 0-30",
		label: "Combined Plantroom",
		source: "UK",
		userSelectable: false,
		consolidationType: true,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: true,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				35,
				999999
			],
			avoidFacadeLocation: [
				"Primary"
			],
			consolidates: [
				"Tank Room CWS Sprinkler",
				"Electrical Intake",
				"Electrical BMS / Comms",
				"Building Thermal Energy",
				"Central Thermal Energy"
			],
			levelLocation: [
				"Ground"
			],
			preferFacadeLocation: [
				"Secondary",
				"Tertiary"
			],
			sizeX: [
				6.9,
				999999
			],
			sizeZ: [
				3.5,
				999999
			],
			sizeY: [
				3,
				999999
			]
		},
		conditions: {
			CentralASHP: true,
			DistrictHeating: true,
			EnergyCentre: true,
			Ffl: [
				0,
				30
			],
			Units: [
				10,
				30
			]
		}
	},
	{
		name: "Mechanical Plantroom 30-100",
		label: "Mechanical plantroom to combine water tanks, pumps, thermal energy plant, control panels etc.",
		source: "UK",
		spaceType: "Mechanical Plant Consolidated - Thermal Store + Tank",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: true,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: true,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				39,
				48
			],
			avoidFacadeLocation: [
				"Primary"
			],
			consolidates: [
				"Tank Room CWS Sprinkler",
				"Building Thermal Energy",
				"Central Thermal Energy"
			],
			levelLocation: [
				"Ground"
			],
			preferFacadeLocation: [
				"Secondary",
				"Tertiary"
			],
			sizeX: [
				5.6,
				999999
			],
			sizeZ: [
				7,
				999999
			],
			sizeY: [
				3,
				999999
			]
		},
		conditions: {
			CentralASHP: true,
			DistrictHeating: true,
			EnergyCentre: true,
			Ffl: [
				0,
				1000
			],
			Units: [
				30,
				100
			]
		}
	},
	{
		name: "Mechanical Plantroom 100-150 Tank",
		label: "Mechanical plantroom to combine water tanks and pumps, Separate plantspace for thermal energy plantroom. 100-150 units.",
		source: "UK",
		spaceType: "Tank Room CWS Sprinkler",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: true,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: true,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				48,
				48
			],
			avoidFacadeLocation: [
				"Primary"
			],
			consolidates: [
				"Tank Room CWS Sprinkler"
			],
			levelLocation: [
				"Ground"
			],
			preferFacadeLocation: [
				"Secondary",
				"Tertiary"
			],
			sizeX: [
				6.9,
				999999
			],
			sizeZ: [
				7,
				999999
			],
			sizeY: [
				3,
				999999
			]
		},
		conditions: {
			Sprinklered: true,
			Ffl: [
				0,
				1000
			],
			Units: [
				100,
				150
			]
		}
	},
	{
		name: "Mechanical Plantroom 100-150 Thermal",
		label: "Mechanical plantroom to combine interface with thermal energy plant and pumps, Separate plant space for CWS tanks. 100-150 units.",
		source: "UK",
		spaceType: "Mechanical Plant Consolidated - Thermal Store",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: true,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: true,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				19,
				24
			],
			avoidFacadeLocation: [
				"Primary"
			],
			consolidates: [
				"Tank Room CWS Sprinkler"
			],
			levelLocation: [
				"Ground"
			],
			preferFacadeLocation: [
				"Secondary",
				"Tertiary"
			],
			sizeX: [
				5.6,
				999999
			],
			sizeZ: [
				3.5,
				999999
			],
			sizeY: [
				3,
				999999
			]
		},
		conditions: {
			CentralASHP: true,
			DistrictHeating: true,
			EnergyCentre: true,
			Ffl: [
				0,
				1000
			],
			Units: [
				100,
				150
			]
		}
	},
	{
		name: "Mechanical Plantroom 150 + Tank ",
		label: "Mechanical plantroom to combine water tanks and pumps, Separate plantspace for thermal energy plantroom. 150 units +. Plant space maybe tight therefore small amount of additional space allowed in thermal plantroom for panels etc.",
		source: "UK",
		spaceType: "Tank Room CWS Sprinkler",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: true,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: true,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				48,
				48
			],
			avoidFacadeLocation: [
				"Primary"
			],
			consolidates: [
				"Tank Room CWS Sprinkler"
			],
			levelLocation: [
				"Ground"
			],
			preferFacadeLocation: [
				"Secondary",
				"Tertiary"
			],
			sizeX: [
				6.9,
				999999
			],
			sizeZ: [
				7,
				999999
			],
			sizeY: [
				3,
				999999
			]
		},
		conditions: {
			Sprinklered: true,
			Ffl: [
				0,
				1000
			],
			Units: [
				150,
				1000
			]
		}
	},
	{
		name: "Mechanical Plantroom 150 + Thermal",
		label: "Mechanical plantroom to combine interface with thermal energy plant and pumps, Separate plant space for CWS tanks. 150 units +. This unit is slightly oversized and can be used with CWS if space required 2 adjacent small modules",
		source: "UK",
		spaceType: "Mechanical Plant Consolidated - Thermal Store",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: true,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: true,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				39,
				48
			],
			avoidFacadeLocation: [
				"Primary"
			],
			consolidates: [
				"Building Thermal Energy",
				"Central Thermal Energy"
			],
			levelLocation: [
				"Ground"
			],
			preferFacadeLocation: [
				"Secondary",
				"Tertiary"
			],
			sizeX: [
				5.6,
				999999
			],
			sizeZ: [
				7,
				999999
			],
			sizeY: [
				3,
				999999
			]
		},
		conditions: {
			CentralASHP: true,
			DistrictHeating: true,
			EnergyCentre: true,
			Ffl: [
				0,
				1000
			],
			Units: [
				150,
				1000
			]
		}
	},
	{
		name: "Electrical Plantroom 30-100",
		label: "Electrical plantroom with LV panel and comms room.",
		source: "UK",
		spaceType: "Electrical Plant Consolidated - Intake + Comms",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: true,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: true,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				24,
				42
			],
			avoidFacadeLocation: [
				"Primary"
			],
			consolidates: [
				"Electrical Intake",
				"Electrical BMS / Comms"
			],
			levelLocation: [
				"Ground"
			],
			preferFacadeLocation: [
				"Secondary",
				"Tertiary"
			],
			sizeX: [
				6.9,
				999999
			],
			sizeZ: [
				3.5,
				999999
			],
			sizeY: [
				3,
				999999
			]
		},
		conditions: {
			Ffl: [
				0,
				1000
			],
			Units: [
				30,
				100
			]
		}
	},
	{
		name: "Electrical Plantroom 100-150 LV",
		label: "Electrical plantroom with LV panel Comms and secondary power separate",
		source: "UK",
		spaceType: "Electrical Intake",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: true,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: true,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				24,
				24
			],
			avoidFacadeLocation: [
				"Primary"
			],
			consolidates: [
				"Electrical Intake"
			],
			levelLocation: [
				"Ground"
			],
			preferFacadeLocation: [
				"Secondary",
				"Tertiary"
			],
			sizeX: [
				6.9,
				999999
			],
			sizeZ: [
				3.5,
				999999
			],
			sizeY: [
				3,
				999999
			]
		},
		conditions: {
			Ffl: [
				0,
				1000
			],
			Units: [
				100,
				150
			]
		}
	},
	{
		name: "Electrical Plantroom 100-150 Sec. LV + Comms",
		label: "Electrical plantroom with secondary LV panel and comms room Main LV board separate module",
		source: "UK",
		spaceType: "Electrical Plant Consolidated - Backup Power + Comms",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: true,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: true,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				19,
				24
			],
			avoidFacadeLocation: [
				"Primary"
			],
			consolidates: [
				"Electrical Intake",
				"Electrical BMS / Comms"
			],
			levelLocation: [
				"Ground"
			],
			preferFacadeLocation: [
				"Secondary",
				"Tertiary"
			],
			sizeX: [
				5.6,
				999999
			],
			sizeZ: [
				3.5,
				999999
			],
			sizeY: [
				3,
				999999
			]
		},
		conditions: {
			Ffl: [
				0,
				1000
			],
			Units: [
				100,
				150
			]
		}
	},
	{
		name: "Electrical Plantroom 150+  LV",
		label: "Electrical plantroom with LV panel Comms and secondary power separate",
		source: "UK",
		spaceType: "Electrical Intake",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: true,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: true,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				24,
				24
			],
			avoidFacadeLocation: [
				"Primary"
			],
			consolidates: [
				"Electrical Intake"
			],
			levelLocation: [
				"Ground"
			],
			preferFacadeLocation: [
				"Secondary",
				"Tertiary"
			],
			sizeX: [
				6.9,
				999999
			],
			sizeZ: [
				3.5,
				999999
			],
			sizeY: [
				3,
				999999
			]
		},
		conditions: {
			Ffl: [
				0,
				1000
			],
			Units: [
				150,
				1000
			]
		}
	},
	{
		name: "Electrical Plantroom 150 Sec. LV + Comms copy",
		label: "Electrical plantroom with secondary LV panel and comms room Main LV board separate module",
		source: "UK",
		spaceType: "Electrical Plant Consolidated - Backup Power + Comms",
		spaceClass: "Service",
		userSelectable: false,
		consolidationType: true,
		attributes: {
			access: "Internal",
			canRotate: true,
			preferredInside: true,
			preferredOutside: false,
			quantity: 1,
			quantityUnit: "Building",
			requiredInside: true,
			requiredOutside: false,
			requiredOnEveryLevel: false,
			requiredToStack: false,
			doorType: "Double",
			area: [
				24,
				24
			],
			avoidFacadeLocation: [
				"Primary"
			],
			consolidates: [
				"Electrical Intake",
				"Electrical BMS / Comms"
			],
			levelLocation: [
				"Ground"
			],
			preferFacadeLocation: [
				"Secondary",
				"Tertiary"
			],
			sizeX: [
				6.9,
				999999
			],
			sizeZ: [
				3.5,
				999999
			],
			sizeY: [
				3,
				999999
			]
		},
		conditions: {
			Ffl: [
				0,
				1000
			],
			Units: [
				150,
				1000
			]
		}
	}
];

export { spaces as default };
//# sourceMappingURL=spaces-list.json.js.map
